import * as React from 'react';
import { UtilityText } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useConfigApp } from '@web-config-app/core-react';
import { CollapsibleSection } from '@web-config-app/core-react-ui';
import type { EntityFormControlProps } from '../../types/controls';
import { DefaultLocaleImagePreview } from './default-locale-image-preview.component';
import { DefaultLocaleTextPreview } from './default-locale-text-preview.component';

type DefaultLocalePreviewProps = Pick<
  EntityFormControlProps,
  'showDefaultLocale' | 'defaultLocaleData' | 'schema'
>;

export const DefaultLocalePreview: React.FC<DefaultLocalePreviewProps> = ({
  showDefaultLocale,
  defaultLocaleData,
  schema,
}) => {
  const { formatMessage } = useIntl();
  const { defaultLocale } = useConfigApp();

  if (!showDefaultLocale) return null;

  const isImageFileControl =
    schema?.['x-entity-control']?.type === 'assetFile' &&
    schema?.['x-entity-control']?.options?.file?.fileType === 'image';
  return (
    <CollapsibleSection
      label={formatMessage({ id: 'VIEW_DEFAULT_LOCALE' })}
      css={{ marginBlockStart: '$half' }}
    >
      <UtilityText
        emphasis="subtle"
        as="p"
        size="xs"
        css={{ fontWeight: '$bold' }}
      >
        {defaultLocale}
      </UtilityText>

      {isImageFileControl ? (
        <DefaultLocaleImagePreview defaultLocaleData={defaultLocaleData} />
      ) : (
        <DefaultLocaleTextPreview defaultLocaleData={defaultLocaleData} />
      )}
    </CollapsibleSection>
  );
};
